import { useQuery } from '@tanstack/react-query'
import { useNavigate, useParams, useSearch } from '@tanstack/react-router'
import { useEffect } from 'react'

import { documentOCRListQuery } from '@/lib/queries/business/v1/ocr/task/queries'

import { type DocumentData } from './ui/document-list/types'

export const useProcessDocumentReviewPage = () => {
  const navigate = useNavigate()
  const { jobId } = useParams({ from: '/process-document/review/$jobId' })
  const { taskId: taskIdSearchParam } = useSearch({ from: '/process-document/review/$jobId' })

  const { data: documentOCRListData } = useQuery(documentOCRListQuery(jobId ? parseInt(jobId) : undefined))

  const ocrDocumentList: DocumentData[] = documentOCRListData
    ? documentOCRListData.map(({ fileName, taskId, isReviewed }) => ({
        taskId,
        name: fileName,
        isActive: taskId === taskIdSearchParam,
        isReviewed,
      }))
    : []

  useEffect(
    function setInitialTaskId() {
      if (!taskIdSearchParam && documentOCRListData) {
        const firstOCRDocumentItem = documentOCRListData[0]

        void navigate({
          to: '/process-document/review/$jobId',
          params: {
            jobId,
          },
          search: {
            taskId: firstOCRDocumentItem.taskId,
          },
        })
      }
    },
    [navigate, jobId, taskIdSearchParam, documentOCRListData]
  )

  return { ocrDocumentList }
}
